@if (errorMessages().length > 0) {
  <div
    class="w-full ord-body-2 text-left px-3 py-2 rounded text-rose-600 border border-rose-200 bg-rose-100"
  >
    <!-- Header -->
    <div class="flex items-start justify-start gap-3">
      <mat-icon svgIcon="error-alert" class="ord-icon mt-1 opacity-80" />
      <span
        class="flex-1"
        [class]="{
          'ord-subtitle-2': errorMessages().length > 1,
        }"
      >
        {{ errorMessages().length === 1 ? errorMessages()[0] : "Errors:" }}
      </span>
    </div>

    <!-- List (only if multiple) -->
    @if (errorMessages().length > 1) {
      <ol class="mt-1">
        @for (error of errorMessages(); track $index) {
          <li class="list-decimal list-inside text-sm">
            <span class="italic">{{ error }}</span>
          </li>
        }
      </ol>
    }
  </div>
}
